import script from "./classInfoDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./classInfoDetails.vue?vue&type=script&setup=true&lang=js"

import "./classInfoDetails.vue?vue&type=style&index=0&id=74eaa9ff&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74eaa9ff"]])

export default __exports__